const GRADE_LABELS = Object.freeze({
  VERY_FAVORABLE: "Very Favorable",
  FAVORABLE: "Favorable",
  NEUTRAL: "Neutral",
  DIFFICULT: "Difficult",
  VERY_DIFFICULT: "Very Difficult",
  UNAVAILABLE: "Unavailable",
});

export const MATCHUP_FILTER_OPTIONS = Object.freeze([
  { value: "ANY", label: "Any" },
  { value: "VERY_FAVORABLE", label: GRADE_LABELS.VERY_FAVORABLE },
  { value: "FAVORABLE", label: GRADE_LABELS.FAVORABLE },
  { value: "NEUTRAL", label: GRADE_LABELS.NEUTRAL },
  { value: "DIFFICULT", label: GRADE_LABELS.DIFFICULT },
  { value: "VERY_DIFFICULT", label: GRADE_LABELS.VERY_DIFFICULT },
  { value: "UNAVAILABLE", label: GRADE_LABELS.UNAVAILABLE },
]);

const finite = (value) => {
  const number = Number(value);
  return value !== null && value !== undefined && value !== "" && Number.isFinite(number) ? number : null;
};

export const matchupGradeLabel = (grade) => GRADE_LABELS[String(grade || "").trim().toUpperCase()] || GRADE_LABELS.UNAVAILABLE;

export const hasCanonicalMatchupContract = (row = {}) => {
  const status = String(row.matchup_status || "").trim().toUpperCase();
  const grade = String(row.matchup_grade || "").trim().toUpperCase();
  const rank = finite(row.matchup_rank);
  const fieldSize = finite(row.matchup_field_size);
  const percentile = finite(row.matchup_percentile);
  const population = String(row.matchup_population ?? "").trim();
  const market = String(row.matchup_market || "").trim();
  return status === "AVAILABLE" && grade in GRADE_LABELS && grade !== "UNAVAILABLE" &&
    rank !== null && fieldSize !== null && rank >= 1 && rank <= fieldSize && fieldSize >= 1 &&
    percentile !== null && percentile >= 0 && percentile <= 1 && Boolean(population) && Boolean(market);
};

export const candidateSupportsCanonicalMatchup = (rows) => Array.isArray(rows) && rows.some(hasCanonicalMatchupContract);

export const filterRowsByMatchupGrade = (rows, selectedGrade) => {
  const safeRows = Array.isArray(rows) ? rows : [];
  const grade = String(selectedGrade || "ANY").trim().toUpperCase();
  if (grade === "ANY" || !candidateSupportsCanonicalMatchup(safeRows)) return safeRows;
  return safeRows.filter((row) => String(row.matchup_grade || "UNAVAILABLE").trim().toUpperCase() === grade);
};

export const canonicalMatchupPresentation = (row = {}) => {
  const grade = String(row.matchup_grade || "UNAVAILABLE").trim().toUpperCase();
  const gradeLabel = matchupGradeLabel(grade);
  const rank = finite(row.matchup_rank);
  const fieldSize = finite(row.matchup_field_size);
  const percentile = finite(row.matchup_percentile);
  const available = String(row.matchup_status || "").trim().toUpperCase() === "AVAILABLE" &&
    grade !== "UNAVAILABLE" && rank !== null && fieldSize !== null && rank >= 1 && rank <= fieldSize;
  return {
    available,
    grade: grade in GRADE_LABELS ? grade : "UNAVAILABLE",
    gradeLabel: available ? gradeLabel : GRADE_LABELS.UNAVAILABLE,
    rank: available ? rank : null,
    fieldSize: available ? fieldSize : null,
    percentile: percentile !== null && percentile >= 0 && percentile <= 1 ? percentile : null,
    percentileLabel: percentile !== null && percentile >= 0 && percentile <= 1 ? `${Math.round(percentile * 100)}%` : "Unavailable",
    rankLabel: available ? `${Math.trunc(rank)}/${Math.trunc(fieldSize)}` : "Unavailable",
    gradeRankLabel: available ? `${gradeLabel} · ${Math.trunc(rank)}/${Math.trunc(fieldSize)}` : GRADE_LABELS.UNAVAILABLE,
  };
};
